import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["alt", "height", "width", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'img-hover': $props.imgHover,
    }, "profile-wrapper"]),
    style: _normalizeStyle({ height: `${$setup.profileSize}px`, width: `${$setup.profileSize}px` })
  }, [
    ($props.pathImg && !$setup.imgLoadError)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "rounded-circle",
          alt: $props.altText,
          height: $setup.profileSize,
          width: $setup.profileSize,
          src: $props.pathImg,
          onerror: $setup.handleImgError
        }, null, 8 /* PROPS */, _hoisted_1))
      : (_openBlock(), _createBlock($setup["IconMaterial"], {
          key: 1,
          icon: "person",
          size: $setup.profileSize,
          color: "#f8fafc"
        }, null, 8 /* PROPS */, ["size"]))
  ], 6 /* CLASS, STYLE */))
}